module.exports = __webpack_public_path__ + "img/index15.2c210f87.png";